import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { questService } from '@/services/quest';
import { computed } from 'vue';

export function useQuestTypeList() {
    const crudAction = useCrudActions();

    const { list, total, fetchList } = useBaseListView({ request: questService.type.list });

    const questTypeOptions = computed(() => list.value.map((type: any) => ({ label: type.name, value: type.id })));
    const questTypeOptionWithAll = computed(() => [{ label: 'All', value: -1 }, ...questTypeOptions.value]);

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: questService.type.disable,
            onSuccess: () => fetchList()
        }),
        disableNext: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to disable this type in next cycle?',
            request: questService.type.disableNext,
            onSuccess: () => fetchList()
        }),
        enableNext: crudAction.confirmAndExecute({
            confirmMessage: 'Are you sure you want to enable this type in next cycle?',
            request: questService.type.enableNext,
            onSuccess: () => fetchList()
        }),
        remove: crudAction.confirmAndRemove({
            request: questService.type.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, questTypeOptions, questTypeOptionWithAll, actions };
}
